<template>
  <div>
    <el-dialog
      class="course-result-chose-modal-contain clearfix"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="handleCloseModal"
      :width="'1000px'"
      :append-to-body="true"
      :title="$t('res.courseclassroomrela.alternativeCourse')"
    > 
      <div class="course-chose-data">
        <div class="course-chose-lf">
          <article class="course-chose-filter clearfix">
            <div class="filter-module clearfix">
              <span class="filter-module-name">{{ $t('courseTask.courseNameOrCode') }}</span>
              <span class="filter-module-value filter-module-value3">
                <el-input
                  v-model="searchData.courseCodeOrName"
                  @keyup.enter.native="searchDataList()"
                  :placeholder="$t('res.coursetrainerrela.courseNameCode')"
                ></el-input>
              </span>
            </div>
            <div class="filter-module clearfix">
              <span class="filter-module-name">{{ $t('courseSchedule.teamCatalog') }}</span>
              <span class="filter-module-value">
                <el-popover placement="bottom" :width="calWidth"
                      ref="popover"
                      trigger="click">
                    <!--重置-->
                    <el-button @click="resetChecked" type="text" size="mini">{{ $t('reset') }}</el-button>
                    <el-tree style="max-height:400px; overflow-y: auto;"
                            ref="teamClassTree"
                            :data="groupList"
                            show-checkbox
                            :render-after-expand="false"
                            node-key="code"
                            @check-change="handleCheckChange"
                            :props="defaultProps"
                            :default-expand-all="false">
                    </el-tree>
                    <el-input slot="reference"
                              :placeholder="$t('user.select')"
                              clearable
                              readonly
                              v-model.trim="teamName"></el-input>
                </el-popover>
              </span>
            </div>
            <div class="filter-module filter-module2 clearfix">
              <el-button class="add-button" type="primary" @click="searchDataList">
                {{ $t("query") }}
              </el-button>
              <el-button class="add-button" type="info" @click="resetSearch">
                {{ $t("reset") }}
              </el-button>
            </div>
          </article>
          <article class="course-chose-list">
            <el-table border class="course-scheduleTask-result-chose-table" ref="courseTable"
            :data="courseData" stripe @select="selectRedio" @select-all="selectAll" v-loading="loading">
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="45">
              </el-table-column>
              <template v-for="(item,kindex) in courseColumn">
                <el-table-column :prop="item.prop"
                              :key="'courseChose' + kindex +item.prop"
                              show-overflow-tooltip
                              :width="item.width"
                              header-align="center"
                              align="center"
                              :label="item.label">
                </el-table-column>
              </template>
            </el-table>
            <el-pagination
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="total"
              class="course-chose-pagination"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle"
            >
            </el-pagination>
          </article>
        </div>
        <div class="course-chose-lr">
          <article class="course-chose-save">
            <el-button class="add-button" type="primary" @click="choseCourse">
              {{ $t("confirm") }}
            </el-button>
          </article>
          <article class="course-chose-save-list">
            <p class="save-list-title">{{ $t('cert.selectedCourse') }}</p>
            <el-tag show-overflow-tooltip
              v-for="item,index in multipleSelection"
              :key="'result-course'+index"
              @close="handleCloseSelect(item.courseCode)"
              closable>
              <span class="save-list-li-name">{{ item.courseCode + '-' + item.courseName }}</span>
            </el-tag> 
          </article>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String
    },
    courseList: {
      type: Array
    }
  },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      total: 0,
      searchData: {
        courseCodeOrName: ''
      },
      courseData: [],
      teamcatalogOne: this.enums['catalogidList1'],
      teamcatalogSecond: this.enums['catalogidList2'],
      allTeamCatalog: [],
      teamList: [],
      teamListTwo: [],
      teamPerms: 'TRAINERTEAM',
      calWidth: 200,
      loading: false,
      nameLoading: false,
      multipleSelection: [],
      teamName: '',
      timeout: null,
      groupTypeList: [],
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      courseColumn: [
        { prop: 'courseCode', label: this.$t('couse.coursecode') },
        { prop: 'courseName', label: this.$t('couse.coursenamecn'), width: 130 },
        { prop: 'courseKindName', label: this.$t('courseSchedule.courseType') },
        { prop: 'courseTeamCatalogNames', label: this.$t('couse.courseteamcatalogid'), width: 130 }
      ]
    };
  },
  computed: {
    groupList () {
      const data = [];
      const obj = {};
      const codes = this.teamcatalogOne.map((item) => item.code);
      this.teamcatalogOne.forEach((item) => {
        obj[item.code] = { ...item, children: [] };
      });
      // 课程团队分类一级
      this.teamcatalogSecond.forEach(item => {
        const code = item.code.slice(0, 2);
        if (codes.includes(code)) {
          obj[code].children.push({ ...item});
        }
      });
      Object.keys(obj).forEach((item) => {
        data.push(obj[item]);
      });
      return data;
    }
  },
  methods: {
    handleCheckChange () {
      const checkedValTem = this.$refs.teamClassTree.getCheckedNodes(true, false).map((item) => {
        return item;
      });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.teamName = checkedValTem.map((item) => item.name).toString();
        this.groupTypeList = checkedValTem.map(item => item.code);
        this.$refs.popover.doClose();
      }, 300);
    },
    resetChecked () {
      this.teamName = '';
      this.groupTypeList = [];
      this.$refs.teamClassTree.setCheckedKeys([]);
      this.$refs.popover.doClose();
    },
    resetSearch () {
      Object.keys(this.searchData).forEach((item) => {
        this.searchData[item] = '';
      });
      this.groupTypeList = [];
      this.multipleSelection = [];
      this.$refs.teamClassTree.setCheckedKeys([]);
      this.$refs.popover.doClose();
      this.teamName = '';
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    handleCloseModal () {
      this.$emit('closeCourseChose', { courseInfo: {}, show: false });
    },
    getDataList () {
      const params = {
        page: this.pageNum,
        limit: this.pageSize,
        courseCodeOrName: this.searchData.courseCodeOrName,
        scheduleTaskId: this.taskId,
        teamCatalogSeconds: this.groupTypeList.toString()
      };
      this.loading = true;
      this.$request.get('/classschedule/scheduleTaskResult/queryTaskCourseInfo', params).then((res) => {
        if (res) {
          this.total = res.total;
          this.courseData = res.records;
          this.loading = false;
          this.$nextTick(() => {
            if (this.multipleSelection.length > 0) {
              const ids = this.multipleSelection.map((item) => item.courseCode);
              this.courseData.forEach((item) => {
                if (ids.includes(item.courseCode)) {
                  this.$refs.courseTable.toggleRowSelection(item, true);
                }
              });
            }
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    searchDataList () {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    selectRedio (_selection, row) {
      const ids = this.multipleSelection.map((item) => item.courseCode);
      if (!ids.includes(row.courseCode)) {
        this.multipleSelection.push(row);
      } else {
        this.$refs.courseTable.toggleRowSelection(row, false);
        this.multipleSelection.splice( ids.indexOf(row.courseCode), 1);
      }
    },
    selectAll (selection) {
      if (selection.length > 0) {
        const ids = this.multipleSelection.map((item) => item.courseCode);
        selection.forEach((item) => {
          if (!ids.includes(item.courseCode) && item.courseCode.indexOf('children') === -1) {
            this.multipleSelection.push(item);
          }
        });
      } else {
        const delIds = this.courseData.map((item) => item.courseCode);
        const arr = [];
        this.multipleSelection.forEach((item) => {
          if (delIds.includes(item.courseCode)) {
            this.$refs.courseTable.toggleRowSelection(item, false);
          } else {
            arr.push(item);
          }
        });
        this.multipleSelection = arr;
      }
    },
    handleCloseSelect (id) {
      const ids = this.multipleSelection.map((item) => item.courseCode);
      this.multipleSelection.forEach((item) => {
        if (id === item.courseCode) {
          this.$refs.courseTable.toggleRowSelection(item, false);
        }
      })
      this.multipleSelection.splice( ids.indexOf(id), 1);
    },
    pageSizeChangeHandle (val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getDataList();
    },
    pageCurrentChangeHandle (val) {
      this.pageNum = val;
      this.getDataList();
    },
    choseCourse () {
      this.$emit('closeCourseChose', { courseInfo: this.multipleSelection, show: false });
    }
  },
  mounted() {
    this.multipleSelection = this.courseList || [];
    this.getDataList();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.timeout = null;
  },
};
</script>
<style lang="scss" scoped>
.course-result-chose-modal-contain {
  .course-chose-modal-title {
    width: 100%;
  }
  .course-chose-title {
    width: 100%;
    margin: 0 0 15px 0;
  }
  .course-chose-lf {
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    padding: 20px;
    flex: 1;
    overflow: hidden;
  }
  .course-chose-lr{
    margin-left: 20px;
    width: 260px;
    .course-chose-save {
      background-color: #FFF;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      padding: 20px 10px;
      text-align: right;
      margin-bottom: 20px;
    }
    .course-chose-save-list {
      background-color: #FFF;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      padding: 10px;
      height: calc(100% - 96px);
      .save-list-title {
        text-align: center;
      }
      .save-list-li-name {
        width: 190px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-tag {
        width: 100% !important;
        margin-bottom: 5px;
      }
    }
  }
  .course-chose-filter {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .filter-module {
      margin-right: 15px;
      line-height: 34px;
      &.filter-module2 {
        width: 160px;
        margin: 0;
        text-align: right;
        padding-top: 32px;
      }
      .filter-module-name {
        display: block;
        margin-right: 12px;
      }
      .filter-module-value {
        &.filter-module-value2 {
          width: 100px;
          float: left;
        }
        &.filter-module-value3 {
          width: 200px;
        }
        &.filter-module-value4 {
          width: 130px;
          float: left;
        }
      }
    }
  }
  .course-scheduleTask-result-chose-table {
    margin-bottom: 10px;
  }
  .course-chose-pagination {
    text-align: right;
  }
}
</style>
<style lang="scss">
.course-result-chose-modal-contain{
  .el-table__header .el-checkbox {
    display: block !important;
  }
  .el-table__header {
    th {
      background-color: #ebecf0 !important;
      border-right: 1px #dcdee3 solid !important;
    }
  }
  .el-dialog__body {
    padding-top: 0 !important;
  }
  .course-chose-data {
    display: flex !important;
  }
  .el-tag {
    .el-icon-close {
      top: -12px !important;
    }
  }
  .filter-module-value {
    .el-select__tags {
      max-width: 100% !important;
    }
  }
  .filter-module-value2 {
    .el-input__inner {
      border-left: none !important;
    }
  }
  .filter-module-value3 {
    .el-select {
      .el-input .el-input__inner{
        cursor: text !important;
      }
    }
  }
  .el-pagination__total {
    height: 32px !important;
    line-height: 32px !important;
  }
}
</style>